import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TIME_RANGE_PERIOD_OPTIONS, type TimeRangePeriod } from "@/constants/timeRange";

interface TimeRangeTabsProps {
  value: TimeRangePeriod;
  onValueChange: (value: TimeRangePeriod) => void;
  ariaLabel: string;
  className?: string;
}

const TimeRangeTabs = ({ value, onValueChange, ariaLabel, className }: TimeRangeTabsProps) => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={value}
      onValueChange={newValue => onValueChange(newValue as TimeRangePeriod)}
      className={className ?? "shrink-0"}
    >
      <TabsList aria-label={ariaLabel}>
        {TIME_RANGE_PERIOD_OPTIONS.map(option => (
          <TabsTrigger key={option.value} value={option.value}>
            {t(option.translationKey)}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default TimeRangeTabs;
